module.exports = __webpack_public_path__ + "img/chat.7a168015.svg";